import { PublicQuestion } from "@/queries/types";
import styled from "@emotion/styled";
import {
  Content,
  DSTextOption as SystemTextOption,
  DSTextOptionsAnswer as SystemTextOptionsAnswer,
} from "@hundred5/design-system";
import { Dispatch } from "react";
import * as amplitude from "../../../../amplitude";
import { Markdown } from "../../../markdown";
import { Action, State } from "../../reducer";
import { sortOptions } from "../utils";
interface Props {
  question: PublicQuestion;
  dispatch: Dispatch<Action>;
  state: State;
}

export function SingleOptionAnswer({ state, dispatch, question }: Props) {
  const answer = state.answers[question.test_question_id];

  return (
    <SystemTextOptionsAnswer>
      {sortOptions(question?.options || []).map((option) => {
        const optionId = (
          option.test_question_option_id || option.library_question_option_id
        )?.toString();
        return (
          <SystemTextOption
            key={optionId}
            type="single"
            name={`answer-${question.test_question_id}`}
            id={`option-${question.test_question_id}-${optionId}`}
            selected={answer?.chosenOptions[0]?.optionId === optionId}
            disabled={state.submitting}
            onChange={(selected) => {
              if (selected) {
                dispatch({
                  type: "select_single_option_answer",
                  payload: {
                    questionId: question.test_question_id.toString(),
                    optionId: optionId!,
                  },
                });

                amplitude.trackQuestionAnswer(
                  state.jobOpeningSlug,
                  state.activeQuestionIndex,
                );
              }
            }}
          >
            <ContentWrapper>
              <Content>
                <Markdown>{option.content}</Markdown>
              </Content>
            </ContentWrapper>
          </SystemTextOption>
        );
      })}
    </SystemTextOptionsAnswer>
  );
}

//region Styles
const ContentWrapper = styled(Content)`
  margin-top: -10px;
  margin-bottom: -10px;
  display: inline-block;
`;
//endregion
